<script setup lang="ts">
import { onMounted, ref } from "vue";

const gtm: any = useGtm();
const { t } = useI18n();
const isOpenedDrawer = ref(false);
const appLogo = ref("/assets/logo-bali-bikes-main-hz.png");
const isScrolled = ref(false);
const route = useRoute();

// Method to detect scroll position
const handleScroll = () => {
  if (window.scrollY > 70) {
    isScrolled.value = true;
  } else {
    isScrolled.value = false;
  }
};

const chatUs = () => {
  setTimeout(() => {
    gtm.trackEvent({
      event: "btn-contact-us",
      action: "click",
      value: 1,
    });

    window.open("https://wa.me/62811194881", "_blank");
  }, 0);
};

onMounted(() => {
  // Add event listener for scroll
  window.addEventListener("scroll", handleScroll);
});

const isActive = (path: string) => {
  if (path === "/") {
    return route.path === "/";
  }
  return route.fullPath.startsWith(path);
};

const navItems = [
  { path: "/", label: "app.home", id: "btn-header-collection" },
  { path: "/bike", label: "app.bike_collection", id: "btn-header-collection" },
  { path: "/blog", label: "app.blog", id: "btn-header-blog" },
  { path: "/faq", label: "app.faq", id: "btn-header-faq" },
  { path: "/about-us", label: "app.about_us", id: "btn-header-about-us" },
  // {
  //   path: "/contact-us",
  //   label: "Contact Us",
  //   id: "btn-contact-us",
  //   onClick: () => chatUs(),
  // },
];
</script>

<template>
  <div class="!z-10">
    <div class="h-[80px] flex fixed w-full top-0 left-0 !bg-white">
      <div class="flex justify-between items-center container">
        <div class="flex items-center gap-4">
          <Icon
            id="btn-drawer-app"
            size="25"
            name="mdi:menu"
            class="!block md:!hidden md:!gap-8"
            @click="isOpenedDrawer = !isOpenedDrawer"
          />
          <RouterLink
            id="btn-header-logo"
            to="/"
            class="flex items-center max-w-[240px] cursor-pointer"
          >
            <NuxtImg
              preset="thumb"
              :src="appLogo"
              alt="app logo"
              width="150"
              height="30"
              loading="eager"
              format="webp"
              quality="70"
            />
          </RouterLink>
        </div>
        <div class="hidden md:flex gap-8">
          <MazLink
            v-for="item in navItems"
            :key="item.path"
            :to="item.path"
            :color="isActive(item.path) ? 'primary' : 'black'"
            :class="isActive(item.path) && 'font-bold'"
            :id="item.id"
          >
            {{ t(item.label) }}
          </MazLink>
        </div>

        <div class="hidden md:flex items-center gap-4">
          <!-- <AppUser /> -->
          <MazBtn size="sm" @click="chatUs()">Contact Us</MazBtn>
        </div>
      </div>
    </div>

    <MazDrawer variant="top" v-model="isOpenedDrawer">
      <template #title>
        <div class="flex items-center">
          <NuxtImg
            preset="thumb"
            :src="appLogo"
            alt="app-logo"
            class="mr-4 w-36"
          />
        </div>
      </template>

      <template #default="{ close }">
        <div class="p-4 h-screen">
          <ClientOnly>
            <div class="flex gap-4 flex-col">
              <MazLink
                :color="route.fullPath == '/' ? 'primary' : 'black'"
                id="btn-header-collection"
                to="/"
                @click="close"
              >
                {{ t("app.home") }}
              </MazLink>
              <MazLink
                :color="route.fullPath == '/bike' ? 'primary' : 'black'"
                id="btn-header-collection"
                to="/bike"
                @click="close"
              >
                {{ t("app.bike_collection") }}
              </MazLink>

              <!-- <MazLink :color="route.fullPath == '/tour-package' ? 'primary' : 'black'" id="btn-header-tour"
                to="/tour-package" @click="close">
                {{ t("app.tour") }}
              </MazLink> -->

              <MazLink
                :color="route.fullPath == '/blog' ? 'primary' : 'black'"
                id="btn-header-blog"
                to="/blog"
                @click="close"
              >
                {{ t("app.blog") }}
              </MazLink>

              <MazLink
                :color="route.fullPath == '/faq' ? 'primary' : 'black'"
                id="btn-header-faq"
                to="/faq"
                @click="close"
              >
                {{ t("app.faq") }}
              </MazLink>

              <MazLink
                :color="route.fullPath == '/about-us' ? 'primary' : 'black'"
                id="btn-header-about-us"
                to="/about-us"
                @click="close"
              >
                {{ t("app.about_us") }}
              </MazLink>

              <MazLink
                :color="route.fullPath == '/contact-us' ? 'primary' : 'black'"
                id="btn-contact-us"
                :class="route.fullPath == '/contact-us' && 'font-bold'"
                @click="chatUs()"
              >
                Contact Us
              </MazLink>
            </div>
          </ClientOnly>
        </div>
      </template>
    </MazDrawer>
  </div>
</template>
